import React from 'react';
import { connect } from 'react-redux';
import { modeSelectors } from 'selectors/pathBuilder';
import NameInput from './NameInput';
import Actions from './Actions';
import Heading from './Heading';

const PathBuilderHeader = ({ editingMode }) => (
  <div className="PathBuilder-header">
    <div className="d-f jc-sb">
      <Heading />
      <Actions />
    </div>
    {editingMode && <NameInput />}
  </div>
);

const mapStateToProps = ({ pathBuilder }) => ({
  editingMode: modeSelectors.isEdit(pathBuilder),
});

export default connect(mapStateToProps)(PathBuilderHeader);
